import { render, staticRenderFns } from "./registrationLink.vue?vue&type=template&id=17ed322c&scoped=true&"
import script from "./registrationLink.vue?vue&type=script&lang=js&"
export * from "./registrationLink.vue?vue&type=script&lang=js&"
import style0 from "./registrationLink.vue?vue&type=style&index=0&id=17ed322c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ed322c",
  null
  
)

component.options.__file = "registrationLink.vue"
export default component.exports